import { SMART_CONTRACT_TYPES, SMART_CONTRACT_PLUGIN_IDS } from "@/components/SmartContractDesigner/smartContractPluginIDs";
import { DiagramValidationErrorModel } from "../config/DiagramValidationErrorModel";
import { DIAGRAM_ERROR_TYPES } from "../config/DiagramErrorTypes";

export function InvalidBlockEnding(data) {
    const reduced = Object.keys(data.pluginCounts)
        .filter(key => key === SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_DO_WHILE
                    || key === SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_WHILE
                    || key === SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_FOR
                    || key === SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_IF
                    || key === SMART_CONTRACT_TYPES.SMART_CONTRACT_DELIMITATOR)
        .reduce((accumulator, value) => {
            if (value === SMART_CONTRACT_TYPES.SMART_CONTRACT_DELIMITATOR) {
                accumulator.delimitators += data.pluginCounts[value];
            } else {
                accumulator.loops += data.pluginCounts[value];
            }
            return accumulator;
        }, { loops: 0, delimitators: 0 });
    const isValid = reduced.loops === reduced.delimitators;
    if (!isValid) {
        return [
            new DiagramValidationErrorModel({
                type: DIAGRAM_ERROR_TYPES.INVALID_BLOCK_ENDING,
                reason: "Not all block codes seem to be closed!",
                aditional: { loopsCount: reduced.loops, delimitatorsCount: reduced.delimitators }
            })
        ];
    }
    return true;
}
